import { React, useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import lodash from 'lodash';
import Lottie from 'lottie-react-web';

import NewTimeDivisionLine from '../../../Component/MainComponent/NewTimeDivisionLine.js';
import WeeklyColumn from './WeeklyColumn';

import EmptySign from '../../../image/EmptySign.png';
import PlusPath from '../../../image/ClassAddPlus.png';
import WhiteTrashIcon from '../../../image/WhiteTrashIcon.png';

import LoadingAnimation from '../../../Animation/LoadingAnimation.json';
import WeekClassDeleteModal from './ClassManageModal/WeekClassDeleteModal.js';
import FetchModule from '../../Share/Network/FetchModule.js';
import ScheduleClassBox from './ScheduleClassBox.js';

export default function WeeklyClass(props) {
  const {
    index,
    rendering,
    setRendering,
    today,
    isLoading,
    setIsLoading,
    isInProgress,
    setIsInPregress,
    scheduleData,
    breakTimeData,
    changedTeachers,
    canceledSchedules,
    setClickDate,
    onClickDeleteButton,
    onClickScheduleDetail,
    onClickPlusColumn
  } = props;


  const conversionRate = 0.5;

  const [useScheduleData, setUseScheduleData] = useState([]);

  const [totalData, setTotalData] = useState([]);
  const [startDay, setStartDay] = useState(moment());
  const [minHeight, setMinHeight] = useState(644)
  const [isClickedWeekDelete, setIsClickedWeekDelete] = useState(false);
  const [deletedWeek, setDeletedWeek] = useState(undefined);

  const [weekAllDeleteBackgroundHeight, setWeekAllDeleteBackgroundHeight] = useState({ width: 0, height: 0 });

  const TopLevelRef = useRef();
  const ColumnRef = useRef();
  const ComponentRef = useRef([]);
  const InnerComponentRef = useRef([]);
  const DeleteTotalRef = useRef([]);
  const DeleteBackgroundRef = useRef([]);
  const DeleteButtonRef = useRef([]);
  const FirstButtonWrapperRef = useRef([]);
  const FirstButtonRef = useRef([]);
  const ButtonWrapperRef = useRef([]);
  const ButtonRef = useRef([]);

  const prevScheduleDataRef = useRef(null);
  const prevBreakTimeDataRef = useRef(null);
  const prevStartDayRef = useRef(null);

  useEffect(() => {
    if (!ColumnRef.current) return;

    const id = requestAnimationFrame(() => {
      const rect = ColumnRef.current.getBoundingClientRect();
      setWeekAllDeleteBackgroundHeight({ width: rect.width, height: rect.height + 12 + 20 + 28 });
    });

    return () => cancelAnimationFrame(id);
  }, [totalData]);



  // 주간 처음 날짜 빼오기 //
  useEffect(() => {
    for (let i = 0; i < 7; i++) {
      if (today.clone().subtract(i, 'day').format('dd') === 'Su') {
        setStartDay(today.clone().subtract(i, 'day'));
        break;
      }
    }
  }, [today])

  // Schedule Data를 사용 가능한 Data로 가공
  useEffect(() => {
    if (scheduleData.length === 0 && breakTimeData.length === 0) return;

    const isSameSchedule = JSON.stringify(scheduleData) === JSON.stringify(prevScheduleDataRef.current);
    const isSameBreakTime = JSON.stringify(breakTimeData) === JSON.stringify(prevBreakTimeDataRef.current);
    const isSameStartDay = JSON.stringify(startDay) === JSON.stringify(prevStartDayRef.current);

    if (isSameSchedule && isSameBreakTime && isSameStartDay) return;

    prevScheduleDataRef.current = scheduleData;
    prevBreakTimeDataRef.current = breakTimeData;
    prevStartDayRef.current = startDay;

    let tmp = scheduleData.slice();
    let newScheduleData = [];

    for (let i = 0; i < tmp.length; i++) {

      let endPoint = moment(tmp[i].classDate.split('T')[0]);

      if (endPoint.isBefore(startDay)) endPoint = startDay;

      while (endPoint.isBefore(moment(tmp[i].endDate))) {
        if (endPoint.diff(startDay, 'days') >= 7) break;


        if (tmp[i].repeatWeek.includes(getWeekNumber(endPoint.format('YYYY-MM-DD')).toString()) || tmp[i].repeatWeek.includes('0')) {

          if (tmp[i].applyWeek.includes(endPoint.format('ddd')) || tmp[i].applyWeek === 'All') {
            let newData = {
              classId: tmp[i].classId,
              classDate: endPoint.format('YYYY.MM.DD'),
              className: tmp[i].className,
              classTime: tmp[i].classTime,
              color: tmp[i].color,
              endDate: tmp[i].endDate,
              lessonId: tmp[i].lessonId,
              scheduleId: tmp[i].scheduleId,
              teacherName: tmp[i].teacherName,
              applyWeek: tmp[i].applyWeek,
              repeatWeek: tmp[i].repeatWeek,
              maxBookedPeople: tmp[i].maxBookedPeople,
              deduction: tmp[i].deduction,
            }

            newScheduleData.push(newData);
          }
        }

        endPoint = endPoint.clone().add(1, 'day');
      }
    }

    newScheduleData.sort(function (a, b) {
      return a.classDate < b.classDate ? -1 : a.classDate > b.classDate ? 1 : 0;
    })

    let newData = [];

    for (let i = 0; i < newScheduleData.length; i++) {
      for (let j = 0; j < 7; j++) {
        if (newScheduleData[i].classDate === startDay.clone().add(j, 'day').format('YYYY.MM.DD')) {
          newData.push(newScheduleData[i]);
        }
      }
    }

    // breaktime 데이터 가공
    for (let z = 0; z < breakTimeData.length; z++) {
      for (let y = 0; y < 7; y++) {
        if (moment(breakTimeData[z].classDate).isBefore(moment(startDay.clone().add(y, 'day').format('YYYY-MM-DDT') + breakTimeData[z].startTime)) && moment(breakTimeData[z].endDate).isAfter(startDay.clone().add(y, 'day'))) {
          if (breakTimeData[z].repeatWeek.includes(getWeekNumber(startDay.clone().add(y, 'day').format('YYYY-MM-DD'))) || breakTimeData[z].repeatWeek === '0') {
            if (breakTimeData[z].applyWeek.includes(startDay.clone().add(y, 'day').format('ddd')) || breakTimeData[z].applyWeek === 'All') {
              let breakData = {
                breakTimeId: breakTimeData[z].breakTimeId,
                classId: -1,
                lessonId: -1,
                classDate: startDay.clone().add(y, 'day').format('YYYY.MM.DD'),
                color: '#BDBDBD',
                classTime: breakTimeData[z].startTime + '-' + breakTimeData[z].endTime,
                className: '브레이크 타임',
                applyWeek: breakTimeData[z].applyWeek
              }

              newData.push(breakData);
            }
          }
        }
      }
    }

    newData.sort(function (a, b) {
      return a.classTime < b.classTime ? -1 : a.classTime > b.classTime ? 1 : 0;
    })

    // TimeDivisionLine에서 사용할 데이터 가공
    for (let i = 0; i < newData.length; i++) {
      tmp = newData[i].classTime.split('-');
      let splitTmp = tmp[0].split(':');
      let Time = '';

      if (parseInt(splitTmp[0]) === 24) {
        newData[i].startTime = (parseInt(splitTmp[0]) - 12) + ':' + splitTmp[1] + ' AM';
        Time = (parseInt(splitTmp[0]) - 12) + 'AM';
      }
      else if (parseInt(splitTmp[0]) > 12) {
        newData[i].startTime = (parseInt(splitTmp[0]) - 12) + ':' + splitTmp[1] + ' PM';
        Time = (parseInt(splitTmp[0]) - 12) + ' PM';
      }
      else if (parseInt(splitTmp[0]) === 12) {
        newData[i].startTime = (parseInt(splitTmp[0])) + ':' + splitTmp[1] + ' PM';
        Time = (parseInt(splitTmp[0])) + ' PM';
      }
      else {
        newData[i].startTime = splitTmp[0] + ':' + splitTmp[1] + ' AM';
        Time = parseInt(splitTmp[0]) + ' AM';
      }

      tmp = newData[i].classTime.split('-');
      splitTmp = tmp[1].split(':');

      if (parseInt(splitTmp[0]) === 24) {
        newData[i].endTime = (parseInt(splitTmp[0]) - 12) + ':' + splitTmp[i] + 'AM';
      }
      else if (parseInt(splitTmp[0]) > 12) {
        newData[i].endTime = (parseInt(splitTmp[0]) - 12) + ':' + splitTmp[1] + ' PM';
        // 끝나는 시간 소팅을 위해 쓰는 변수 //
      }
      else if (parseInt(splitTmp[0]) === 12) {
        newData[i].endTime = (parseInt(splitTmp[0])) + ':' + splitTmp[1] + ' PM';
      }
      else {
        newData[i].endTime = splitTmp[0] + ':' + splitTmp[1] + ' AM';
      }

      newData[i].end = parseFloat(splitTmp[0] + '.' + splitTmp[1]);

      if (i !== 0 && newData[i - 1].startTime.split(':')[0] === newData[i].startTime.split(':')[0]) {
        newData[i] = Object.assign(newData[i], { isNeedNewDivide: false })
        newData[i] = Object.assign(newData[i], { viewTime: Time })
      }
      else {
        newData[i] = Object.assign(newData[i], { isNeedNewDivide: true })
        newData[i] = Object.assign(newData[i], { viewTime: Time })
      }
    }

    let newReserve = [];

    for (let h = 0; h < newData.length; h++) {
      newReserve.push(new Array());
    }

    setUseScheduleData(newData);
  }, [scheduleData, breakTimeData, startDay])

  // 주간 시간표 데이터 정리 //
  useEffect(() => {
    let tmpData = lodash.cloneDeep(useScheduleData);
    let newTotalData = [];
    let startTimeList = [];

    tmpData.sort(function (a, b) {
      return a.classDate < b.classDate ? -1 : a.classDate > b.classDate ? 1 : 0;
    })

    for (let i = 0; i < tmpData.length; i++) {
      let data = {
        classDate: tmpData[i].classDate,
        startTime: tmpData[i].startTime,
        endTime: tmpData[i].endTime
      }

      startTimeList.push(data);
    }

    let finalStartTime = [];

    for (let i = 0; i < startTimeList.length; i++) {
      let isExist = false;

      for (let j = 0; j < finalStartTime.length; j++) {
        if (startTimeList[i].startTime === finalStartTime[j].startTime) {
          isExist = true;
          break;
        }
      }

      if (!isExist) {
        finalStartTime.push(startTimeList[i]);
      }
    }

    finalStartTime.sort(function (a, b) {
      let aTime = a.startTime.split(' ')[0];
      let aState = a.startTime.split(' ')[1];

      let bTime = b.startTime.split(' ')[0];
      let bState = b.startTime.split(' ')[1];

      if (aState === 'AM' && bState === 'PM') return -1;
      else if (aState === 'PM' && bState === 'AM') return 1;
      else {
        let aHour = aTime.split(':')[0];
        let aMinute = aTime.split(':')[1];
        let aConvertToMinute = 0;

        if (aState === 'PM' && parseInt(aHour) === 12) aConvertToMinute = parseInt(aMinute);
        else aConvertToMinute = (parseInt(aHour) * 60) + parseInt(aMinute);

        let bHour = bTime.split(':')[0];
        let bMinute = bTime.split(':')[1];
        let bConvertToMinute = 0;

        if (bState === 'PM' && parseInt(bHour) === 12) bConvertToMinute = parseInt(bMinute);
        else bConvertToMinute = (parseInt(bHour) * 60) + parseInt(bMinute);

        if (aConvertToMinute > bConvertToMinute) return 1;
        else return -1;
      }
    })

    for (let i = 0; i < finalStartTime.length; i++) {
      let newDataList = [];

      for (let j = 0; j < tmpData.length; j++) {
        // 시작날짜가 같을경우 //
        if (finalStartTime[i].startTime === tmpData[j].startTime) {

          // 중복검사 //
          let isExist = false;

          for (let h = 0; h < newTotalData.length; h++) {
            let isInnerExist = false;

            for (let z = 0; z < newTotalData[h].length; z++) {
              if (newTotalData[h][z].classDate === tmpData[j].classDate
                && newTotalData[h][z].classTime === tmpData[j].classTime
                && newTotalData[h][z].className === tmpData[j].className) {
                isExist = true;
                isInnerExist = true;
                break;
              }
            }

            if (isInnerExist) break;
          }

          if (!isExist) {
            newDataList.push(tmpData[j]);
          }
        }

        // 끝나는 시간이 같은 경우 //
        else if (finalStartTime[i].endTime === tmpData[j].endTime) {

          let isExist = false;

          for (let h = 0; h < newDataList.length; h++) {
            if (newDataList[h].classDate === tmpData[j].classDate
              && newDataList[h].classTime === tmpData[j].classTime
              && newDataList[h].className === tmpData[j].className) {
              isExist = true;
              break;
            }

          }

          if (!isExist) {
            let totalExist = false;

            for (let h = 0; h < newTotalData.length; h++) {
              let isInnerExist = false;
              for (let z = 0; z < newTotalData[h].length; z++) {
                if (newTotalData[h][z].classDate === tmpData[j].classDate
                  && newTotalData[h][z].classTime === tmpData[j].classTime
                  && newTotalData[h][z].className === tmpData[j].className) {
                  totalExist = true;
                  isInnerExist = true;
                  break;
                }
              }

              if (isInnerExist) break;
            }

            if (!totalExist) {
              newDataList.push(tmpData[j]);
            }
          }
        }
      }

      if (newDataList.length !== 0) newTotalData.push(newDataList);
    }

    // 겹치는 시간표 처리 //
    for (let i = 0; i < newTotalData.length; i++) {
      let isNeedDivide = false;
      let dateCheckList = [];

      for (let j = 0; j < newTotalData.length; j++) {
        let isExist = false;

        for (let h = 0; h < dateCheckList.length; h++) {
          // 동일 날짜가 겹치는 부분이 있는경우 체크 //
          if (newTotalData[j].classDate === dateCheckList[h]) isExist = true;
        }

        // 동일 날짜가 겹치는 부분이 있는경우 겹치기 처리 //
        if (isExist) {
          isNeedDivide = true;
          break;
        }
        // 없는경우 검사 리스트에 데이터 추가 //
        else dateCheckList.push(newTotalData[j].classDate);
      }

      // 데이터의 크기가 일정 이상이거나 시간대별 동일 날짜가 겹치는 경우가 있을때 //
      if (newTotalData[i].length > 7 || isNeedDivide) {
        // 분해한 데이터 담을 리스트 //
        let tmpTotalData = [];

        // 날짜별 분해 데이터 담을 리스트 //
        let tmpDivideData = [];

        // 최종 분해 후 재 결합한 데이터 //
        let finalTotalData = [];

        // 최종 분해 후 재 결합한 데이터 //
        let finalDivideData = [];

        // 분해할 데이터 Deep Copy //
        let tmpData = lodash.cloneDeep(newTotalData[i]);

        // 수업을 날짜별로 정렬 //
        tmpData.sort((a, b) => new Date(a.classDate) - new Date(b.classDate));

        for (let j = 0; j < tmpData.length; j++) {
          tmpDivideData = [];

          let isExist = false;

          for (let h = 0; h < tmpTotalData.length; h++) {
            if (tmpTotalData[h][0].classDate === tmpData[j].classDate) {
              tmpTotalData[h].push(tmpData[j]);
              isExist = true;
            }
          }

          // 자리를 찾지 못했으면 리스트 뒤에 추가해주기 //
          if (!isExist) {
            tmpDivideData.push(tmpData[j]);
            tmpTotalData.push(tmpDivideData);
          }
        }

        // 일찍 끝나는 순으로 정렬 //
        for (let j = 0; j < tmpTotalData.length; j++) {
          tmpTotalData[j].sort((a, b) => a.end - b.end);
        }

        // index 최대 길이 구하기 //
        let columnMaxLength = 0;

        for (let j = 0; j < tmpTotalData.length; j++) {
          if (tmpTotalData[j].length > columnMaxLength) columnMaxLength = tmpTotalData[j].length;
        }

        for (let j = 0; j < columnMaxLength; j++) {
          finalDivideData = [];

          for (let h = 0; h < tmpTotalData.length; h++) {
            if (tmpTotalData[h].length > j) {
              finalDivideData.push(tmpTotalData[h][j]);
            }
          }

          finalTotalData.push(finalDivideData);
        }

        newTotalData.splice(i, 1);

        for (let j = 0; j < finalTotalData.length; j++) {
          if (j !== 0) {
            for (let h = 0; h < finalTotalData[j].length; h++) {
              finalTotalData[j][h].isNeedNewDivide = false;
            }
          }
          newTotalData.splice(i + j, 0, finalTotalData[j]);
        }
      }
    }
    // 겹치는 시간표 처리 //

    // 남은 칸 수업없음으로 채우기 //
    for (let i = 0; i < newTotalData.length; i++) {
      for (let j = 0; j < 7; j++) {

        // 데이터 앞에 부족한 부분 채우기 //
        for (let h = 0; h < newTotalData[i].length; h++) {
          if (newTotalData[i].length === 7) break;

          let classDate = startDay.clone().add(j, 'day').format('YYYY.MM.DD');
          let newData = {
            classId: -2,
            classDate: classDate,
            className: '수업없음',
            classTime: ' ',
            teacherName: ' ',
            isNeedNewDivide: newTotalData[i][0].isNeedNewDivide,
            viewTime: newTotalData[i][0].viewTime
          }

          if (classDate === newTotalData[i][h].classDate) break;
          else if (classDate < newTotalData[i][h].classDate) {
            newTotalData[i].push(newData);
            break;
          }
        }
      }

      // 데이터 앞의 부족한 부분을 채우고 칸을 다 못채운 경우에만 해당 //
      if (newTotalData[i].length < 7) {
        while (true) {
          if (newTotalData[i].length === 7) break;

          let classDate = startDay.clone().add(newTotalData[i].length, 'day').format('YYYY.MM.DD');
          let newData = {
            classId: -2,
            classDate: classDate,
            className: '수업없음',
            classTime: ' ',
            teacherName: ' ',
            isNeedNewDivide: newTotalData[i][0].isNeedNewDivide,
            viewTime: newTotalData[i][0].viewTime
          }

          newTotalData[i].push(newData);
        }
      }

      newTotalData[i].sort(function (a, b) {
        return a.classDate < b.classDate ? -1 : a.classDate > b.classDate ? 1 : 0;
      })
    }

    if (changedTeachers.length > 0) {
      const teacherMap = new Map();

      for (const teacher of changedTeachers) {
        const key = `${teacher.scheduleId}_${moment(teacher.classDate).format('YYYY.MM.DD')}`;
        teacherMap.set(key, teacher.teacherNames);
      }

      for (let i = 0; i < newTotalData.length; i++) {
        for (let j = 0; j < newTotalData[i].length; j++) {
          const item = newTotalData[i][j];
          const key = `${item.scheduleId}_${item.classDate}`;
          
          const teacherNames = teacherMap.get(key);

          if (teacherNames) {
            const names = teacherNames.split(',');

            item.isChangedTeachers = true;
            item.teacherNames = names;
            // item.teacherName = names.length > 1
            //   ? `${names[0]} Coach 외 ${names.length - 1}`
            //   : `${names[0]} Coach`;
            
            item.teacherName = names.length > 0
              ? `${names[0]} Coach`
              : ``;
          }
          else {
            item.isChangedTeachers = false;
            item.teacherNames = [];
          }
        }
      }
    }

    setTotalData(newTotalData);

    setTimeout(() => {
      setIsLoading(false);
    }, 500);

  }, [useScheduleData, changedTeachers, startDay])

  useEffect(() => {
    if (!isLoading) {
      setMinHeight(ColumnRef.current.clientHeight);
    }
  }, [isLoading, ColumnRef])

  // 몇주차인지 계산하기 //
  function getWeekNumber(date) {
    const standard = new Date(date);

    const currentDate = standard.getDate();
    const startOfMonth = new Date(standard.setDate(1));
    const weekDay = startOfMonth.getDay();

    return parseInt(((weekDay - 1) + currentDate) / 7) + 1;
  }

  // 호버링 배경색 컬러 코드에서 RGB값으로 변경 //
  function hexToRGB(hex, alpha) {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    if (alpha) return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ")";
    else return 'rgba(' + r + ', ' + g + ', ' + b + ")";
  }

  // 비어있는칸 플러스 버튼 클릭시 //
  function onClickPlusColumnBox(outData, innerData) {
    let settingTime = '';

    for (let i = 0; i < outData.length; i++) {
      if (outData[i].classId !== -1 && outData[i].classId !== -2) {
        settingTime = outData[i].classTime;
        break;
      }
    }

    onClickPlusColumn(innerData.classDate, settingTime, moment(innerData.classDate).format('ddd,'));
  }

  // 수업시간의 차이로 인한 윗쪽 빈칸 플러스 버튼 클릭시 //
  function onClickTopPlusColumnBox(outData, innerData) {
    let settingStartTime = '';
    let settingEndTime = innerData.classTime.split('-')[0];
    let originalClassTime = innerData.classTime;

    for (let i = 0; i < outData.length; i++) {
      if (outData[i].classId !== -1 && outData[i].classId !== -2 && outData[i].classTime !== originalClassTime) {
        settingStartTime = outData[i].classTime.split('-')[0];
        break;
      }
    }

    let settingTime = settingStartTime + '-' + settingEndTime;

    onClickPlusColumn(innerData.classDate, settingTime, moment(innerData.classDate).format('ddd,'));
  }
  // 수업시간의 차이로 인한 아랫쪽 빈칸 플러스 버튼 클릭시 //
  function onClickBottomPlusColumnBox(outData, innerData) {
    let settingStartTime = innerData.classTime.split('-')[1];
    let settingEndTime = '';
    let originalClassTime = innerData.classTime;

    for (let i = 0; i < outData.length; i++) {
      if (outData[i].classId !== -1 && outData[i].classId !== -2 && outData[i].classTime !== originalClassTime) {
        settingEndTime = outData[i].classTime.split('-')[1];
        break;
      }
    }

    let settingTime = settingStartTime + '-' + settingEndTime;

    onClickPlusColumn(innerData.classDate, settingTime, moment(innerData.classDate).format('ddd,'));
  }

  // 맨 위에 칸 플러스 버튼 클릭시 //
  function onClickFirstPlusColumnBox(innerData) {
    onClickPlusColumn(innerData.classDate, '', moment(innerData.classDate).format('ddd,'));
  }

  // 수업 정보 컴포넌트 사이에 추가버튼을 띄울지 결정 //
  function selectBetweenButtonView(outerIndex, innerIndex) {
    // 마지막 컴포넌트는 버튼 추가 X //
    if (totalData.length === outerIndex + 1) return true;
    else {
      // 본 컴포넌트 아래에 수업없음이라 추가 컴포넌트가 존재하는 경우 //
      if (totalData[outerIndex + 1][innerIndex].className === '수업없음') return false;
      else return true;
    }
  }

  // 첫줄 추가 버튼 호버링 시작 시 //
  function onMouseEnterOfFirstButton(index) {
    ComponentRef.current[index].style.transform = 'translate(0px, 6px)';

    FirstButtonWrapperRef.current[index].style.marginTop = `-14px`;

    FirstButtonRef.current[index].style.height = `18px`;
    FirstButtonRef.current[index].style.backgroundColor = `#FF8B48`;
    FirstButtonRef.current[index].style.opacity = '1';
  }

  // 첫줄 추가 버튼 호버링 끝 //
  function onMouseLeaveOfFirstButton(index) {
    ComponentRef.current[index].style.transform = 'translate(0px, 0px)';

    FirstButtonWrapperRef.current[index].style.marginTop = `-8px`;

    FirstButtonRef.current[index].style.height = `8px`;

    FirstButtonRef.current[index].style.backgroundColor = `#FFFFFF`;
    FirstButtonRef.current[index].style.opacity = '0';
  }

  // 마우스 호버링 시작시 //
  function onMouseEnter(outerIndex, innerIndex, topMargin) {
    ComponentRef.current[(outerIndex * 7) + innerIndex].style.transform = 'translate(0px, -6px)';

    if (totalData.length > (outerIndex + 1)) ComponentRef.current[((outerIndex + 1) * 7) + innerIndex].style.transform = 'translate(0px, 6px)';

    ButtonWrapperRef.current[(outerIndex * 7) + innerIndex].style.marginTop = (topMargin - 3) + 'px';

    ButtonRef.current[(outerIndex * 7) + innerIndex].style.height = `18px`;
    ButtonRef.current[(outerIndex * 7) + innerIndex].style.backgroundColor = `#FF8B48`;
    ButtonRef.current[(outerIndex * 7) + innerIndex].style.opacity = '1';
  }

  // 마우스 호버링 끝날시 //
  function onMouseLeave(outerIndex, innerIndex, topMargin) {
    ComponentRef.current[(outerIndex * 7) + innerIndex].style.transform = 'translate(0px, 0px)';

    if (totalData.length > (outerIndex + 1)) ComponentRef.current[((outerIndex + 1) * 7) + innerIndex].style.transform = 'translate(0px, 0px)';

    ButtonWrapperRef.current[(outerIndex * 7) + innerIndex].style.marginTop = (topMargin + 2) + 'px';

    ButtonRef.current[(outerIndex * 7) + innerIndex].style.height = `8px`;
    ButtonRef.current[(outerIndex * 7) + innerIndex].style.backgroundColor = `#FFFFFF`;
    ButtonRef.current[(outerIndex * 7) + innerIndex].style.opacity = '0';
  }

  // 주간 데이터 클릭시
  function onClickWeeklyScheduleBox(data) {
    if (data.className !== '브레이크 타임' && data.className !== '수업없음') {
      setClickDate(data.classDate);
      onClickScheduleDetail(data.scheduleId, data);
    }
  }

  // 수업 삭제 버튼 클릭시 //
  function onClickDeletedClass(data) {
    onClickDeleteButton(data);
  }

  // 수업 시간에 따른 수업 추가 버튼 크기 계산 //
  function onCalcNoneTDHeight(data) {
    let finalStartTime = 0;
    let finalEndTime = 0;

    for (let i = 0; i < data.length; i++) {
      if (data[i].className !== '수업없음') {
        let startTime = data[i].classTime.split('-')[0];
        let endTime = data[i].classTime.split('-')[1];

        let startTimeHour = parseInt(startTime.split(':')[0]);
        let startTimeMinute = parseInt(startTime.split(':')[1]);

        let endTimeHour = parseInt(endTime.split(':')[0]);
        let endTimeMinute = parseInt(endTime.split(':')[1]);

        let startValue = 0;
        let endValue = 0;

        if (startTimeMinute >= 55) startValue = startTimeHour + 0.91;
        else if (startTimeMinute >= 50) startValue = startTimeHour + 0.83;
        else if (startTimeMinute >= 45) startValue = startTimeHour + 0.75;
        else if (startTimeMinute >= 40) startValue = startTimeHour + 0.66;
        else if (startTimeMinute >= 35) startValue = startTimeHour + 0.58;
        else if (startTimeMinute >= 30) startValue = startTimeHour + 0.5;
        else if (startTimeMinute >= 25) startValue = startTimeHour + 0.41;
        else if (startTimeMinute >= 20) startValue = startTimeHour + 0.33;
        else if (startTimeMinute >= 15) startValue = startTimeHour + 0.25;
        else if (startTimeMinute >= 10) startValue = startTimeHour + 0.16;
        else if (startTimeMinute >= 5) startValue = startTimeHour + 0.08;
        else startValue = startTimeHour;

        if (endTimeMinute >= 55) endValue = endTimeHour + 0.91;
        else if (endTimeMinute >= 50) endValue = endTimeHour + 0.83;
        else if (endTimeMinute >= 45) endValue = endTimeHour + 0.75;
        else if (endTimeMinute >= 40) endValue = endTimeHour + 0.66;
        else if (endTimeMinute >= 35) endValue = endTimeHour + 0.58;
        else if (endTimeMinute >= 30) endValue = endTimeHour + 0.5;
        else if (endTimeMinute >= 25) endValue = endTimeHour + 0.41;
        else if (endTimeMinute >= 20) endValue = endTimeHour + 0.33;
        else if (endTimeMinute >= 15) endValue = endTimeHour + 0.25;
        else if (endTimeMinute >= 10) endValue = endTimeHour + 0.16;
        else if (endTimeMinute >= 5) endValue = endTimeHour + 0.08;
        else endValue = endTimeHour;

        if (finalStartTime === 0 && finalEndTime === 0) {
          finalStartTime = startValue;
          finalEndTime = endValue;
        }
        else {
          if (finalStartTime > startValue) finalStartTime = startValue;
          if (finalEndTime < endValue) finalEndTime = endValue;
        }
      }
    }

    let finalRate = finalEndTime - finalStartTime;

    if (finalRate < 1.5) return 66 + 2;
    else {
      // return ((((finalRate - 1) * conversionRate) + 1) * 66) - 4;
      return ((((finalRate - 1) * conversionRate) + 1) * 66) + 2;
    }
  }

  // 수업 시간에 따른 크기 변환 계산 //
  function onCalcTDHeight(data) {
    let startTime = data.classTime.split('-')[0];
    let endTime = data.classTime.split('-')[1];

    let startTimeHour = parseInt(startTime.split(':')[0]);
    let startTimeMinute = parseInt(startTime.split(':')[1]);

    let endTimeHour = parseInt(endTime.split(':')[0]);
    let endTimeMinute = parseInt(endTime.split(':')[1]);

    let startValue = 0;
    let endValue = 0;

    if (startTimeMinute >= 55) startValue = startTimeHour + 0.91;
    else if (startTimeMinute >= 50) startValue = startTimeHour + 0.83;
    else if (startTimeMinute >= 45) startValue = startTimeHour + 0.75;
    else if (startTimeMinute >= 40) startValue = startTimeHour + 0.66;
    else if (startTimeMinute >= 35) startValue = startTimeHour + 0.58;
    else if (startTimeMinute >= 30) startValue = startTimeHour + 0.5;
    else if (startTimeMinute >= 25) startValue = startTimeHour + 0.41;
    else if (startTimeMinute >= 20) startValue = startTimeHour + 0.33;
    else if (startTimeMinute >= 15) startValue = startTimeHour + 0.25;
    else if (startTimeMinute >= 10) startValue = startTimeHour + 0.16;
    else if (startTimeMinute >= 5) startValue = startTimeHour + 0.08;
    else startValue = startTimeHour;

    if (endTimeMinute >= 55) endValue = endTimeHour + 0.91;
    else if (endTimeMinute >= 50) endValue = endTimeHour + 0.83;
    else if (endTimeMinute >= 45) endValue = endTimeHour + 0.75;
    else if (endTimeMinute >= 40) endValue = endTimeHour + 0.66;
    else if (endTimeMinute >= 35) endValue = endTimeHour + 0.58;
    else if (endTimeMinute >= 30) endValue = endTimeHour + 0.5;
    else if (endTimeMinute >= 25) endValue = endTimeHour + 0.41;
    else if (endTimeMinute >= 20) endValue = endTimeHour + 0.33;
    else if (endTimeMinute >= 15) endValue = endTimeHour + 0.25;
    else if (endTimeMinute >= 10) endValue = endTimeHour + 0.16;
    else if (endTimeMinute >= 5) endValue = endTimeHour + 0.08;
    else endValue = endTimeHour;

    let finalRate = endValue - startValue;

    if (finalRate < 1.5) return 66;
    else return (((finalRate - 1) * conversionRate) + 1) * 66;
  }

  // 수업 시간에 따른 크기 변환 ( 호버링 전용 ) 계산 //
  function onCalcHoverTDHeight(data) {
    let startTime = data.classTime.split('-')[0];
    let endTime = data.classTime.split('-')[1];

    let startTimeHour = parseInt(startTime.split(':')[0]);
    let startTimeMinute = parseInt(startTime.split(':')[1]);

    let endTimeHour = parseInt(endTime.split(':')[0]);
    let endTimeMinute = parseInt(endTime.split(':')[1]);

    let startValue = 0;
    let endValue = 0;

    if (startTimeMinute >= 55) startValue = startTimeHour + 0.91;
    else if (startTimeMinute >= 50) startValue = startTimeHour + 0.83;
    else if (startTimeMinute >= 45) startValue = startTimeHour + 0.75;
    else if (startTimeMinute >= 40) startValue = startTimeHour + 0.66;
    else if (startTimeMinute >= 35) startValue = startTimeHour + 0.58;
    else if (startTimeMinute >= 30) startValue = startTimeHour + 0.5;
    else if (startTimeMinute >= 25) startValue = startTimeHour + 0.41;
    else if (startTimeMinute >= 20) startValue = startTimeHour + 0.33;
    else if (startTimeMinute >= 15) startValue = startTimeHour + 0.25;
    else if (startTimeMinute >= 10) startValue = startTimeHour + 0.16;
    else if (startTimeMinute >= 5) startValue = startTimeHour + 0.08;
    else startValue = startTimeHour;

    if (endTimeMinute >= 55) endValue = endTimeHour + 0.91;
    else if (endTimeMinute >= 50) endValue = endTimeHour + 0.83;
    else if (endTimeMinute >= 45) endValue = endTimeHour + 0.75;
    else if (endTimeMinute >= 40) endValue = endTimeHour + 0.66;
    else if (endTimeMinute >= 35) endValue = endTimeHour + 0.58;
    else if (endTimeMinute >= 30) endValue = endTimeHour + 0.5;
    else if (endTimeMinute >= 25) endValue = endTimeHour + 0.41;
    else if (endTimeMinute >= 20) endValue = endTimeHour + 0.33;
    else if (endTimeMinute >= 15) endValue = endTimeHour + 0.25;
    else if (endTimeMinute >= 10) endValue = endTimeHour + 0.16;
    else if (endTimeMinute >= 5) endValue = endTimeHour + 0.08;
    else endValue = endTimeHour;

    let finalRate = endValue - startValue;

    if (finalRate < 1.5) return 64;
    else return ((((finalRate - 1) * conversionRate) + 1) * 66) - 2;
  }

  // 같은 시간대에 있는 수업이 너무 긴경우 아랫쪽에 수업 추가 버튼을 생성할지 말지 결정 //
  function onCalcUpAdditionalButtonHeight(weeklyData, data) {
    let minimumStartTime = 0;

    for (let i = 0; i < weeklyData.length; i++) {
      if (weeklyData[i].className !== '수업없음') {
        let startTime = weeklyData[i].classTime.split('-')[0];

        let startTimeHour = parseInt(startTime.split(':')[0]);
        let startTimeMinute = parseInt(startTime.split(':')[1]);

        let startValue = 0;

        if (startTimeMinute >= 55) startValue = startTimeHour + 0.91;
        else if (startTimeMinute >= 50) startValue = startTimeHour + 0.83;
        else if (startTimeMinute >= 45) startValue = startTimeHour + 0.75;
        else if (startTimeMinute >= 40) startValue = startTimeHour + 0.66;
        else if (startTimeMinute >= 35) startValue = startTimeHour + 0.58;
        else if (startTimeMinute >= 30) startValue = startTimeHour + 0.5;
        else if (startTimeMinute >= 25) startValue = startTimeHour + 0.41;
        else if (startTimeMinute >= 20) startValue = startTimeHour + 0.33;
        else if (startTimeMinute >= 15) startValue = startTimeHour + 0.25;
        else if (startTimeMinute >= 10) startValue = startTimeHour + 0.16;
        else if (startTimeMinute >= 5) startValue = startTimeHour + 0.08;
        else startValue = startTimeHour;

        if (minimumStartTime === 0) {
          minimumStartTime = startValue;
        }
        else {
          if (minimumStartTime > startValue) minimumStartTime = startValue;
        }
      }
    }

    let startTime = data.classTime.split('-')[0];

    let startTimeHour = parseInt(startTime.split(':')[0]);
    let startTimeMinute = parseInt(startTime.split(':')[1]);

    let startValue = 0;

    if (startTimeMinute >= 55) startValue = startTimeHour + 0.91;
    else if (startTimeMinute >= 50) startValue = startTimeHour + 0.83;
    else if (startTimeMinute >= 45) startValue = startTimeHour + 0.75;
    else if (startTimeMinute >= 40) startValue = startTimeHour + 0.66;
    else if (startTimeMinute >= 35) startValue = startTimeHour + 0.58;
    else if (startTimeMinute >= 30) startValue = startTimeHour + 0.5;
    else if (startTimeMinute >= 25) startValue = startTimeHour + 0.41;
    else if (startTimeMinute >= 20) startValue = startTimeHour + 0.33;
    else if (startTimeMinute >= 15) startValue = startTimeHour + 0.25;
    else if (startTimeMinute >= 10) startValue = startTimeHour + 0.16;
    else if (startTimeMinute >= 5) startValue = startTimeHour + 0.08;
    else startValue = startTimeHour;

    let finalRate = startValue - minimumStartTime;

    if ((finalRate) === 0) return 0;
    else if (finalRate < 0.5) return 0;
    // Margin Top : 6px 부분 빼기 //
    else return ((finalRate * conversionRate) * 64) - 8 - 6;
  }

  // 같은 시간대에 있는 수업이 너무 긴경우 아랫쪽에 수업 추가 버튼을 생성할지 말지 결정 //
  function onCalcDownAdditionalButtonHeight(weeklyData, data) {
    let maximumEndTime = 0;

    for (let i = 0; i < weeklyData.length; i++) {
      if (weeklyData[i].className !== '수업없음') {
        let endTime = weeklyData[i].classTime.split('-')[1];

        let endTimeHour = parseInt(endTime.split(':')[0]);
        let endTimeMinute = parseInt(endTime.split(':')[1]);

        let endValue = 0;

        if (endTimeMinute >= 55) endValue = endTimeHour + 0.91;
        else if (endTimeMinute >= 50) endValue = endTimeHour + 0.83;
        else if (endTimeMinute >= 45) endValue = endTimeHour + 0.75;
        else if (endTimeMinute >= 40) endValue = endTimeHour + 0.66;
        else if (endTimeMinute >= 35) endValue = endTimeHour + 0.58;
        else if (endTimeMinute >= 30) endValue = endTimeHour + 0.5;
        else if (endTimeMinute >= 25) endValue = endTimeHour + 0.41;
        else if (endTimeMinute >= 20) endValue = endTimeHour + 0.33;
        else if (endTimeMinute >= 15) endValue = endTimeHour + 0.25;
        else if (endTimeMinute >= 10) endValue = endTimeHour + 0.16;
        else if (endTimeMinute >= 5) endValue = endTimeHour + 0.08;
        else endValue = endTimeHour;

        if (maximumEndTime === 0) {
          maximumEndTime = endValue;
        }
        else {
          if (maximumEndTime < endValue) maximumEndTime = endValue;
        }
      }
    }

    let endTime = data.classTime.split('-')[1];

    let endTimeHour = parseInt(endTime.split(':')[0]);
    let endTimeMinute = parseInt(endTime.split(':')[1]);

    let endValue = 0;

    if (endTimeMinute >= 55) endValue = endTimeHour + 0.91;
    else if (endTimeMinute >= 50) endValue = endTimeHour + 0.83;
    else if (endTimeMinute >= 45) endValue = endTimeHour + 0.75;
    else if (endTimeMinute >= 40) endValue = endTimeHour + 0.66;
    else if (endTimeMinute >= 35) endValue = endTimeHour + 0.58;
    else if (endTimeMinute >= 30) endValue = endTimeHour + 0.5;
    else if (endTimeMinute >= 25) endValue = endTimeHour + 0.41;
    else if (endTimeMinute >= 20) endValue = endTimeHour + 0.33;
    else if (endTimeMinute >= 15) endValue = endTimeHour + 0.25;
    else if (endTimeMinute >= 10) endValue = endTimeHour + 0.16;
    else if (endTimeMinute >= 5) endValue = endTimeHour + 0.08;
    else endValue = endTimeHour;

    let finalRate = maximumEndTime - endValue;

    if (finalRate === 0) return 0;
    else if (finalRate < 0.5) return 0;
    // Margin Top : 6px 부분 빼기 //
    else return (((finalRate * conversionRate) * 64) - 8 - 6);
  }

  // 주간 삭제 버튼 클릭시 //
  function onClickWeeklyDeleteButton(data, index) {
    let deletedScheduleIds = [];
    let deletedBreakTimeIds = [];

    for (let i = 0; i < totalData.length; i++) {
      if (totalData[i][index].classId === -1) deletedBreakTimeIds.push(totalData[i][index].breakTimeId);
      else if (totalData[i][index].classId !== -2) deletedScheduleIds.push(totalData[i][index].scheduleId);
    }

    setDeletedWeek({
      scheduleIds: deletedScheduleIds,
      breakTimeIds: deletedBreakTimeIds,
      changeApplyWeek: data.format('ddd,'),
      deletedDate: data.format('YYYY-MM-DDTHH:mm:ss')
    });

    setIsClickedWeekDelete(true);
  }

  // 주간 삭제 취소 클릭시 //
  function onClickExitWeeklyDeleteButton() {
    if (isInProgress) {
      alert('삭제가 진행중입니다');
      return;
    }

    setDeletedWeek(undefined);
    setIsClickedWeekDelete(false);
  }

  // 수업 내역 삭제모달 안에서 삭제 클릭시 //
  function onClickOnlyOneDeleteWeek() {

    if (isInProgress) {
      alert('삭제가 진행중입니다');
      return;
    }
    else if (deletedWeek === undefined) {
      alert('삭제할 수업 일정을 선택해주세요');
      return;
    }

    setIsInPregress(true);

    let requestData = {
      scheduleIds: deletedWeek.scheduleIds,
      breakTimeIds: deletedWeek.breakTimeIds,
      changeApplyWeek: deletedWeek.changeApplyWeek,
      deletedDate: moment(deletedWeek.deletedDate).format('YYYY-MM-DDT00:00:00')
    }
    // console.log(requestData);
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('schedule/delete/week/only_one', 'POST', requestData);

        if (responseData.status === 200) {
          setDeletedWeek(undefined);
          setIsClickedWeekDelete(false);
          setRendering(!rendering);
          setIsInPregress(false);
        }
        else {
          alert('삭제에 실패하였습니다.\n잠시 후 다시시도해주세요');
          setIsClickedWeekDelete(false);
          setIsInPregress(false);
        }
      }
    )();
  }

  // 수업 내역 삭제모달 안에서 삭제 클릭시 //
  function onClickDeleteWeek() {

    if (isInProgress) {
      alert('삭제가 진행중입니다');
      return;
    }
    else if (deletedWeek === undefined) {
      alert('삭제할 수업 일정을 선택해주세요');
      return;
    }

    setIsInPregress(true);

    let requestData = {
      scheduleIds: deletedWeek.scheduleIds,
      breakTimeIds: deletedWeek.breakTimeIds,
      changeApplyWeek: deletedWeek.changeApplyWeek,
      deletedDate: moment(deletedWeek.deletedDate).format('YYYY-MM-DDT00:00:00')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('schedule/delete/week', 'POST', requestData);

        if (responseData.status === 200) {
          setDeletedWeek(undefined);
          setIsClickedWeekDelete(false);
          setRendering(!rendering);
          setIsInPregress(false);
        }
        else {
          alert('삭제에 실패하였습니다.\n잠시 후 다시시도해주세요');
          setIsClickedWeekDelete(false);
          setIsInPregress(false);
        }
      }
    )();
  }

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      {
        isClickedWeekDelete &&
        <WeekClassDeleteModal
          deletedData={deletedWeek}
          onClickExit={onClickExitWeeklyDeleteButton}
          onClickOnlyOneDelete={onClickOnlyOneDeleteWeek}
          onClickAllDelete={onClickDeleteWeek} />
      }
      <WeeklyColumn
        isLoading={isLoading}
        height={weekAllDeleteBackgroundHeight}
        today={startDay}
        standardDate={today}
        onClickWeeklyDeleteButton={onClickWeeklyDeleteButton} />
      {
        isLoading ?
          <LoadingWrapper minHeight={minHeight} >
            <LottieWrapper>
              <Lottie options={{ animationData: LoadingAnimation }} />
            </LottieWrapper>
          </LoadingWrapper>
          :
          <ColumnWrapper ref={ColumnRef}>
            {
              totalData.length !== 0 ?
                <TableWrapper>
                  <TimeDivisionLineWrapper>
                    {
                      totalData.map((data, index) => (
                        <NewTimeDivisionLine
                          key={'NewTimeDivisionLine-' + index}
                          index={index}
                          conversionRate={conversionRate}
                          totalData={totalData} />
                      ))
                    }
                  </TimeDivisionLineWrapper>
                  <Table>
                    <Tbody>
                      {
                        totalData.map((data, totalIndex) => (
                          <Tr key={'Total' + index + '-' + totalIndex}>
                            {
                              data.map((innerData, idx) => (
                                innerData.className === '수업없음' ?
                                  <ComponentWrapper key={'Class-' + idx}>
                                    <TDWrapper ref={(element) => ComponentRef.current[(totalIndex * 7) + idx] = element}>
                                      <NoneClassTd
                                        height={onCalcNoneTDHeight(data)}
                                        // height={onCalcTDHeight(data)}
                                        backgroundColor={hexToRGB('#ECECEC', 0.8)}
                                        onClick={() => onClickPlusColumnBox(data, innerData)}>
                                        <Plus src={PlusPath} />
                                      </NoneClassTd>
                                    </TDWrapper>
                                    <BetweenEmptyBox ref={(element) => ButtonRef.current[(totalIndex * 7) + idx] = element} />
                                  </ComponentWrapper>
                                  :
                                  <ComponentWrapper
                                    key={'Class-' + idx}>
                                    {
                                      totalIndex === 0 &&
                                      <FirstPlusButtonWrapper
                                        ref={(element) => FirstButtonWrapperRef.current[idx] = element}
                                        onMouseEnter={() => onMouseEnterOfFirstButton(idx)}
                                        onMouseLeave={() => onMouseLeaveOfFirstButton(idx)}>
                                        <FirstPlusButton
                                          ref={(element) => FirstButtonRef.current[idx] = element}
                                          onClick={() => onClickFirstPlusColumnBox(innerData)}>
                                          <BetweenPlusWidth />
                                          <BetweenPlusHeight />
                                        </FirstPlusButton>
                                      </FirstPlusButtonWrapper>
                                    }
                                    {
                                      onCalcUpAdditionalButtonHeight(data, innerData) !== 0 &&
                                      <TDWrapper>
                                        <NoneClassTd
                                          style={{ marginBottom: '6px' }}
                                          height={onCalcUpAdditionalButtonHeight(data, innerData)}
                                          backgroundColor={hexToRGB('#ECECEC', 0.8)}
                                          onClick={() => onClickTopPlusColumnBox(data, innerData)}>
                                          <Plus src={PlusPath} />
                                        </NoneClassTd>
                                      </TDWrapper>
                                    }
                                    <TDWrapper ref={(element) => ComponentRef.current[(totalIndex * 7) + idx] = element}>
                                      <ScheduleClassBox
                                        totalIndex={totalIndex}
                                        idx={idx}
                                        data={innerData}
                                        canceledSchedules={canceledSchedules}
                                        conversionRate={conversionRate}
                                        onClickWeeklyScheduleBox={onClickWeeklyScheduleBox}
                                        onClickDeletedClass={onClickDeletedClass} />
                                    </TDWrapper>
                                    {
                                      onCalcDownAdditionalButtonHeight(data, innerData) !== 0 &&
                                      <TDWrapper>
                                        <NoneClassTd
                                          style={{ marginTop: '6px' }}
                                          height={onCalcDownAdditionalButtonHeight(data, innerData)}
                                          backgroundColor={hexToRGB('#ECECEC', 0.8)}
                                          onClick={() => onClickBottomPlusColumnBox(data, innerData)}>
                                          <Plus src={PlusPath} />
                                        </NoneClassTd>
                                      </TDWrapper>
                                    }
                                    {
                                      (onCalcDownAdditionalButtonHeight(data, innerData) === 0 && selectBetweenButtonView(totalIndex, idx)) ?
                                        <BetweenPlusButtonWrapper
                                          ref={(element) => ButtonWrapperRef.current[(totalIndex * 7) + idx] = element}
                                          marginTop={onCalcTDHeight(innerData)}
                                          onMouseEnter={() => onMouseEnter(totalIndex, idx, onCalcTDHeight(innerData))}
                                          onMouseLeave={() => onMouseLeave(totalIndex, idx)}>
                                          <BetweenPlusButton
                                            ref={(element) => ButtonRef.current[(totalIndex * 7) + idx] = element}
                                            onClick={() => onClickPlusColumnBox(data, innerData)}>
                                            <BetweenPlusWrapper>
                                              <BetweenPlusWidth />
                                              <BetweenPlusHeight />
                                            </BetweenPlusWrapper>
                                          </BetweenPlusButton>
                                        </BetweenPlusButtonWrapper>
                                        :
                                        <BetweenEmptyBox />
                                    }
                                  </ComponentWrapper>
                              ))
                            }
                          </Tr>
                        ))
                      }
                    </Tbody>
                  </Table>
                </TableWrapper>
                :
                <EmptyClassInfoBox>
                  <EmptyImage src={EmptySign} />
                  <EmptyText>수업이 존재하지 않습니다</EmptyText>
                </EmptyClassInfoBox>
            }
          </ColumnWrapper>
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  // margin-top: 28px;
`;

const ColumnWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  z-index: 6;
`;

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 974px;
  min-height: ${props => props.minHeight}px;
`;

const TableWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;
  
  // width: 974px;
  width: 994px;
  height: auto;
  
  gap: 10px;
`;

const TimeDivisionLineWrapper = styled.div`
	display: flex;
	flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  min-width: 70px;
`;

const Table = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: calc(100% - 80px);
  // width: 100%;
`;

const Tbody = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  gap: 8px;
`;

const Tr = styled.div` 
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;
  
  width: 911px;

  gap: 6px;
  margin: 0 0 0 0;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  transition: all 0.3s ease-in-out;
`;

const TDWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  transition: all 0.1s ease-in-out;
`;

const Td = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 121px;
  height: ${props => props.height}px;

  border: 1px solid ${props => props.color};
  border-radius: 4px;
  background-color: ${props => props.backgroundColor};

  :hover {
    width: 119px;
    height: ${props => props.hoverHeight}px;

    border: 2px solid ${props => props.color};
    cursor: ${props => props.isValid ? `pointer` : `default`};
    background-color: ${props => props.hoverBackColor};
  }
`;

const DeleteButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  margin-top: -2px;

  // width: 125px;
  width: 123px;
  height: calc(100% + 4px);

  z-index: 5;
  opacity: 0;

  overflow: hidden;
  background-color: transparent;
`;

const DeleteBackground = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  z-index: 3;

  width: 20px;
  height: 17px;

  border-radius: 15px 0px 0px 90px;
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;
`;

const DeleteButton = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 17px;

  border-radius: 0px 4px 0px 4px;
  background-color: #FF3131;

  z-index: 6;

  :hover {
    cursor: pointer;
  }

  transition: none;
`;

const DeleteIcon = styled.img`
  width: 12px;
  height: 12px;
`;

const BetweenEmptyBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 68px;

  width: 50px;
  height: 8px;

  opacity: 0;
  background-color: #FFFFFF;
`;

const BetweenPlusButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: ${props => props.marginTop}px;

  width: 125px;

  :hover {
    cursor: pointer;
  }

  transition: all 0.1s ease-in-out;
`;

const BetweenPlusButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50px;
  height: 8px;

  opacity: 0;

  border-radius: 4px;
  background-color: #FFFFFF;

  transition: all 0.1s ease-in-out;
`;

const BetweenPlusWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 12px;
  height: 100%;
`;

const BetweenPlusWidth = styled.div`
  position: absolute;

  width: 7px;
  height: 1px;

  border-radius: 3px;
  background-color: #FFFFFF;
`;

const BetweenPlusHeight = styled.div`
  position: absolute;

  width: 1px;
  height: 7px;

  border-radius: 3px;
  background-color: #FFFFFF;
`;

const FirstPlusButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: -8px;

  width: 125px;

  :hover {
    cursor: pointer;
  }
  
  transition: all 0.1s ease-in-out;
`;

const FirstPlusButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50px;
  height: 8px;

  opacity: 0;

  border-radius: 4px;
  background-color: #FFFFFF;

  transition: all 0.1s ease-in-out;
`;

const NoneClassTd = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  // width: 117px;
  width: 123px;
  height: ${props => props.height}px;

  // border: 4px solid #FFFFFF;
  border-radius: 4px;
  background-color: ${props => props.backgroundColor};
  
  overflow: hidden;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
    // border: 4px solid #FF8B48;
    background-color: #FF8B48;
  }
`;

const Plus = styled.img`
  width: 20px;
  height: 20px;
`;

const TextWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: 2px;
  margin-left: -16px;

  width: 93px;
  height: 50px;

  z-index: 4;
`;

const ClassName = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 12px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  width: 100%;
  min-height: 17px;

  overflow: hidden;
`;

const ClassTime = styled.p`
  font-family: Poppins-Regular;
  font-size: 10px;

  color: #FFFFFF;

  margin: 0 0 0 0;
`;

const ClassNameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 110px;
  height: 17px;

  overflow: hidden;
`;

const ClassTimeWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 110px;
  height: 16px;

  overflow: hidden;
`;

const CoachNameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 110px;
  height: 15px;

  overflow: hidden;
`;

const CoachName = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 10px;

  color: #FFFFFF;

  margin: 0 0 0 0;
`;

const EmptyClassInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 974px;
  height: 644px;
`;

const EmptyImage = styled.img`
  width: 148px;
  height: 62px;
`;

const EmptyText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #CBCBCB;

  margin: 8px 0 0 0;

  :hover {
    cursor: default;
  }
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 60px;
  height: 60px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }
`;